import {BaseFragment, BaseFragmentProps, BaseFragmentState} from "../shared/BaseFragment";
import React from "react";
import {CheckinPlayerFragment} from "../checkin-shared/checkin/CheckinPlayerPreviewFragment";
import {Page, Pages} from "../libwyze-shared/types";
import {AppPrefs} from "./app_prefs";
import {renderErrorCode} from "../shared/BaseApp";
import {CheckinErrorCodes} from "../checkin-common/types";

export type MainProps = BaseFragmentProps&{}

type MainState = BaseFragmentState&{
  practicePage: Page,
}
export class Main extends BaseFragment<MainProps,MainState> {

  protected async fetchOnMount(forceReload?: boolean): Promise<any> {
    const practiceId = AppPrefs.getInstance().getSelectedPracticeId();
    if (practiceId) {
      this.setState({
        practicePage: await Pages.getInstance().getOrLoadItem(practiceId),
      });
    }
  }

  protected renderContainerContent(): React.ReactElement | null {
    if (!this.state.practicePage) {
      return renderErrorCode(CheckinErrorCodes.ERROR_NO_PRACTICE_ID);
    }
    return <CheckinPlayerFragment path={this.props.path} practicePage={this.state.practicePage} noChrome={true}/>;
  }
}